import { Input } from 'antd'
import Flex from 'components/Flex'
import InputNumber from 'components/Form/InputNumber'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const CapInputNumber = styled(InputNumber)`
  .ant-input-number-handler-wrap {
    display: none !important;
  }
`
export const TitleDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
  margin-top: 6px;
  margin-right: 10px;
  width: 50%;
`
export const TextContainer = styled.div`
  margin: 0;
  padding: 0;
`
export const TextLine = styled.p`
  color: #7d7d7d;
  font-size: 14px;
  margin: 0px;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 32px 15px;
  border-top: none;
`
export const StyledInput = styled(Input)(() => ({
  '.ant-input-group .ant-input': {
    width: '64px',
    height: 38,
    borderRadius: '10px',
    float: 'right',
  },
  '.ant-input-group-addon': {
    background: 'transparent',
    border: 'none',
  },
}))
export const StyledBoldTextOne = styled.div`
  font-weight: 600;
  color: ${props => (props?.red ? `${COLORS.ERROR}` : '#010e30')};
  font-size: 13px;
`
export const StyledBoldTextTwo = styled.div`
  font-weight: 600;
  color: #010e30;
  width: auto;
  font-size: 13px;
`
export const InputFlexContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  ${'' /* justify-content: space-between; */}
  margin-bottom: 1rem;
`
export const ContentMainContainer = styled.div`
  margin-top: 5%;
`
export const CheckboxTextContent = styled.div`
  display: flex;
  width: 250px;
  align-items: center;
`
export const StyledSelectDiv = styled(Flex)`
  height: 48px;
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-right: 0;
  }
`
